import React from 'react';
import { connect } from 'react-redux';
import { withPrefix, Link } from 'gatsby';
import { getIcon } from '../../utils';
import Icon from '../Icon';
import {
  header,
  header__logo,
  header__logo_open,
  header__menu
} from './Header.module.scss';
import { toggleDrawer as toggleDrawerAction } from '../../state/app';

const Header = ({ logo, isDrawerOpen, toggleDrawer }) => (
  <header className={header}>
    <a className={header__menu} onClick={() => toggleDrawer(!isDrawerOpen)}>
      <Icon icon={getIcon('menu')} />
    </a>
    <Link className={`${header__logo} ${isDrawerOpen ? header__logo_open : null}`} to="/">
      <img
        src={withPrefix(logo.path)}
        width={logo.width}
        height={logo.height}
        alt={logo.title}
      />
      {logo.subtitle}
    </Link>
  </header>
);

export default connect(
  (state) => ({ isDrawerOpen: state.app.isDrawerOpen }),
  (dispatch) => ({ toggleDrawer: (open) => dispatch(toggleDrawerAction(open)) }),
)(Header);
